var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.8 18.8",
    style: {
      enableBackground: "new 0 0 18.8 18.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M15.5,10.2H3.3c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h12.2c0.3,0,0.6-0.3,0.6-0.6 C16.1,10.4,15.8,10.2,15.5,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M15.5,3.4H3.3C3,3.4,2.7,3.7,2.7,4c0,0.3,0.3,0.6,0.6,0.6h12.2c0.3,0,0.6-0.3,0.6-0.6 C16.1,3.7,15.8,3.4,15.5,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M15.5,6.8H3.3C3,6.8,2.7,7,2.7,7.4c0,0.3,0.3,0.6,0.6,0.6h12.2c0.3,0,0.6-0.3,0.6-0.6 C16.1,7,15.8,6.8,15.5,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M16.9,0H1.9C0.9,0,0,0.9,0,1.9v10.9c0,1.1,0.9,1.9,1.9,1.9h7.5l4.4,3.9c0.1,0.1,0.3,0.2,0.5,0.1 c0.2,0,0.3-0.1,0.4-0.2s0.1-0.3,0.1-0.4l-0.4-3.4h2.5c1.1,0,1.9-0.9,1.9-1.9V1.9C18.8,0.9,17.9,0,16.9,0z M17.6,12.8 c0,0.4-0.3,0.8-0.8,0.8h-3.2c0,0,0,0-0.1,0c-0.3,0-0.5,0.3-0.5,0.6l0.3,2.6L10,13.7c-0.1-0.1-0.2-0.1-0.4-0.1H1.9 c-0.4,0-0.8-0.3-0.8-0.8h0V1.9c0-0.4,0.3-0.8,0.8-0.8h14.9c0.4,0,0.8,0.3,0.8,0.8V12.8z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.57ee5da5.svg";
export { ForwardRef as ReactComponent };